import { render, staticRenderFns } from "./centros-de-custo.vue?vue&type=template&id=665866a4&"
import script from "./centros-de-custo.vue?vue&type=script&lang=js&"
export * from "./centros-de-custo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports